import utils$1 from '../utils.js';

var utils = utils$1;

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

export { normalizeHeaderName as default };
//# sourceMappingURL=normalizeHeaderName.js.map
